import { store } from '../../../core/Store';
import { Actions } from './reducer';
import * as Selectors from './selectors';
import * as Api from './api';

export { Actions, Selectors, Api };

export const initBodyScrollTracker = () => {
	window.addEventListener('scroll', () => {
		const current = Selectors.getIsBodyScrolled(store.getState());
		const isBodyScrolled =
			(document.documentElement.scrollTop /
				(document.documentElement.scrollHeight -
					document.documentElement.clientHeight)) *
				100 >
			0;

		if (current === isBodyScrolled) return;
		store.dispatch(Actions.setIsBodyScrolled(isBodyScrolled));
	});
};

export const initViewportWidthTracker = () => {
	window.addEventListener('resize', () => {
		const viewportWidth = window.innerWidth;
		store.dispatch(Actions.setViewportWidth(viewportWidth));
	});
};

export const checkPaymentStatus = async () => {
	const status = await Api.getStatus();

	if (status?.orderStatus !== 'SUCCESS') return;

	store.dispatch(Actions.setPaymentStatus('finished'));
};
